import React, { Component, PureComponent, Fragment } from 'react'
import { Portal } from 'semantic-ui-react'

export default function Modal(props) {
  let { open = false, children, onClose, actions = [], wrap = false, ...customProps } = props

  let innerModal = (
    <Fragment>
      <div className="modal-content">{children}</div>
      <div className="modal-actions">
        {actions}
        <button className="modal-action-cancel" onClick={e => e.preventDefault() & onClose()}>
          Sulje
        </button>
      </div>
    </Fragment>
  )

  return (
    <Portal open={open} {...customProps}>
      <div className="modal">
        <div className="modal-inner">{wrap ? React.createElement(wrap, customProps, innerModal) : innerModal}</div>
      </div>
    </Portal>
  )
}
